import { render, staticRenderFns } from "./ProductsBottomNavComponent.vue?vue&type=template&id=090cb0e1&scoped=true&"
import script from "./ProductsBottomNavComponent.vue?vue&type=script&lang=js&"
export * from "./ProductsBottomNavComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductsBottomNavComponent.vue?vue&type=style&index=0&id=090cb0e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090cb0e1",
  null
  
)

export default component.exports